"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const asyncBatcher = require("@tanstack/pacer/async-batcher");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useAsyncBatcher(fn, options = {}, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().asyncBatcher,
    ...options
  };
  const [asyncBatcher$1] = react.useState(
    () => new asyncBatcher.AsyncBatcher(fn, mergedOptions)
  );
  asyncBatcher$1.fn = fn;
  asyncBatcher$1.setOptions(mergedOptions);
  const state = reactStore.useStore(asyncBatcher$1.store, selector);
  return react.useMemo(
    () => ({
      ...asyncBatcher$1,
      state
    }),
    // omit `store` in favor of `state`
    [asyncBatcher$1, state]
  );
}
exports.useAsyncBatcher = useAsyncBatcher;
//# sourceMappingURL=useAsyncBatcher.cjs.map
